export const SERVICE_OPTIONS = ['Massage', 'Facial', 'IPL/Waxing', 'FJ', 'BJ', 'JuaGen', 'Bubble Bath'];
